import {
  V2ListRolesForAccountApiArg,
  useV2ListRolesForAccountQuery,
} from "@generated";
import type { Role } from "../types";

export interface UseRolesListArgs {
  page?: V2ListRolesForAccountApiArg["page"];
}

export interface RolesListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useRolesList = ({ page }: UseRolesListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListRolesForAccountQuery(
      { page },
      // Refetch on remount (e.g. returning from Edit) so saves are reflected.
      { refetchOnMountOrArgChange: true }
    );

  const rows: Role[] = (data?.data ?? []).map((role) => ({
    id: String(role.id),
    name: role.attributes?.name ?? "",
    default: role.attributes?.default,
  }));

  const pageMeta: RolesListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useRolesList;
